<template>
  <div id="question-related">
    <evaluation-selection @unanswered="$emit('unanswered')" @answered="$emit('answered')" @editQuestion="$emit('editQuestion')" @cancelQuestion="$emit('cancelQuestion')"></evaluation-selection>
    <div class="aside-user">
      <div class="question-user">
        <div class="role">提问人</div>
        <div class="name">{{ getQuestionDetail.creatorName }}</div>
      </div>
      <div class="user-line"></div>
      <div class="answer-user">
        <div class="role">解答人</div>
        <div class="name">小管子</div>
      </div>
    </div>
    <more-relevant @handler_getQuestionDetail="handler_getQuestionDetail"></more-relevant>
    <rating v-if="getQuestionDetail.creatorId === getUserId && solved"></rating>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import evaluationSelection from '../evaluation-selection/evaluation-selection'
import moreRelevant from '../more-relevant/more-relevant'
import rating from '../rating/rating'

export default {
  name: 'question-related',
  props: {
    label: Number
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getQuestionDetail',
      'getRelatedQuizDetail',
      'getUserId'
    ]),
    solved () {
      return this.getQuestionDetail.status === 2 && this.getQuestionDetail.isSolved === 1
    }
  },
  components: {
    evaluationSelection,
    moreRelevant,
    rating
  },
  methods: {
    handler_getQuestionDetail (id) {
      this.$emit('handler_getQuestionDetail', id)
    }
  },
  filters: {
    setAnonymous (value) {
      if (value && value !== '小管子') {
        let firstName = value.slice(0, 1)
        let name = '**'
        return firstName + name
      }
    }
  }
}
</script>

<style scoped>
  #question-related {
    /*width: 377px;*/
    width: calc(31% - 8px);
    /*max-height: 630px;*/
    overflow-x: hidden;
    overflow-y: scroll;
  }
  #question-related::-webkit-scrollbar {
    width: 4px;
  }
  #question-related::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0);
  }
  #question-related:hover::-webkit-scrollbar-thumb {
    background-color: #ccc;
  }

  .aside-user {
    position: relative;
    /*width: 375px;*/
    width: 100%;
    margin-bottom: 12px;
    background: #fff;
  }

  .question-user, .answer-user {
    display: flex;
    justify-content: space-between;
    height: 44px;
    line-height: 44px;
  }

  .question-user div, .answer-user div {
    margin: 0 14px 0 15px;
    font-size: 15px;
    color: #333333;
    letter-spacing: -0.36px;
  }

  .role {
    padding-left: 26px;
    background: url("../../icons/questioner.svg") no-repeat left center;
  }

  .name {
    padding-right: 16px;
  }

  .user-line {
    position: absolute;
    top: 44px;
    right: 0;
    /*width: 332px;*/
    width: calc(100% - 41px);
    height: 1px;
    box-shadow: 0 0 1px 1px #E0E0E0 inset;
  }
</style>



// WEBPACK FOOTER //
// src/components/question-related/question-related.vue